import { render } from "./RCI.vue?vue&type=template&id=2d14b2d8&scoped=true"
import script from "./RCI.vue?vue&type=script&lang=js"
export * from "./RCI.vue?vue&type=script&lang=js"

import "./RCI.vue?vue&type=style&index=0&id=2d14b2d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d14b2d8"]])

export default __exports__